import Vuex from "vuex";
import Vue from "vue";
import createPersistedState from "vuex-persistedstate";
import app from "./modules/app";
import media from "./modules/media";
import mutations from "./mutation-types";
import post from "./modules/post";
import user from "./modules/user";
import plan from "./modules/plan";
import payment from "./modules/payment";
import drag from "./modules/d&d";
import repost from "./modules/repost";
import bulk from "./modules/bulk";

Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    app,
    media,
    post,
    user,
    plan,
    payment,
    drag,
    repost,
    bulk,
  },
  plugins: [createPersistedState()],
});
export default store;

export function clear() {
  mutations.forEach((type) => {
    store.commit(type, null);
  });
}
